module.exports = __webpack_public_path__ + "static/media/sb.c23eab6d.svg";